const vP18249 = require("./365.js");
exports.mul = function (p18250, p18251) {
  const v14040 = new Uint8Array(p18250.length + p18251.length - 1);
  for (let vLN02585 = 0; vLN02585 < p18250.length; vLN02585++) {
    for (let vLN02586 = 0; vLN02586 < p18251.length; vLN02586++) {
      v14040[vLN02585 + vLN02586] ^= vP18249.mul(p18250[vLN02585], p18251[vLN02586]);
    }
  }
  return v14040;
};
exports.mod = function (p18252, p18253) {
  let v14041 = new Uint8Array(p18252);
  while (v14041.length - p18253.length >= 0) {
    const v14042 = v14041[0];
    for (let vLN02587 = 0; vLN02587 < p18253.length; vLN02587++) {
      v14041[vLN02587] ^= vP18249.mul(p18253[vLN02587], v14042);
    }
    let vLN02588 = 0;
    while (vLN02588 < v14041.length && v14041[vLN02588] === 0) {
      vLN02588++;
    }
    v14041 = v14041.slice(vLN02588);
  }
  return v14041;
};
exports.generateECPolynomial = function (p18254) {
  let v14043 = new Uint8Array([1]);
  for (let vLN02589 = 0; vLN02589 < p18254; vLN02589++) {
    v14043 = exports.mul(v14043, new Uint8Array([1, vP18249.exp(vLN02589)]));
  }
  return v14043;
};